import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Icon, Button} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../common/actions';
import StoragePageTable from '../../storage/table';
import './storageCarInfo.scss';

class StorageCarInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData() {
    const {storageCar} = this.props;
    this.props.fetchPendingLinesToStorageByCar(storageCar, 'checked');
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  onCloseStorageCarClick() {
    const {storageCar} = this.props;
    this.props.changeStorageCarStatus(storageCar, 'fillCar', {});
    this.onCloseModalClick();
  }

  render() {
    const {modalWasOpen} = this.state;
    const {storageCar, loading, pendingLinesList} = this.props;

    return (
      <Modal
        size='large'
        onOpen={() => this.fetchData()}
        className='checking-modal'
        open={modalWasOpen}
        trigger={
          <span className='storage-car'>
            <span className='storage-car-number'>{storageCar}</span>
            <Icon name='shopping cart' size='huge' color='red' />
          </span>
        }
      >
        <Modal.Header>
          ¿Está seguro que desea cerrar el coche {storageCar}?
        </Modal.Header>

        <Modal.Content scrolling>
          <Modal.Description>
            <div>
              <strong>Cantidad de Items</strong>{' '}
              <span className='quantity-container'>
                {_.sumBy(pendingLinesList, 'quantity') || 0}
              </span>
            </div>
            <StoragePageTable
              loading={loading}
              pendingLinesList={pendingLinesList}
            />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => this.onCloseModalClick()}>Cancelar</Button>
          <Button positive onClick={() => this.onCloseStorageCarClick()}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.storage.loadingLines,
    'pendingLinesList': state.storage.pendingLinesList,
  };
};

const {
  fetchPendingLinesToStorageByCar,
  changeStorageCarStatus,
} = Actions;

export default connect(mapStateToProps, {
  fetchPendingLinesToStorageByCar,
  changeStorageCarStatus,
})(StorageCarInfoModal);
